// AuthContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';


const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(() => {
        //const savedUser = localStorage.getItem('user');
        const savedUser = Cookies.get('user');
        return savedUser ? JSON.parse(savedUser) : null;
    });

    useEffect(() => {
        if (user) {
            //localStorage.setItem('user', JSON.stringify(user));
            Cookies.set('user', JSON.stringify(user), { expires: 7 });
        } else {
            //localStorage.removeItem('user');
            Cookies.remove('user');
        }
    }, [user]);

    const login = (userData) => {
        setUser(userData);
    };

    const logout = () => {
        setUser(null);
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
};

// Create a custom hook for using the Auth Context
export const useAuth = () => {
    return useContext(AuthContext);
};